import { ng } from '@uirouter/angularjs/lib/angular';
import { StateService } from '@uirouter/core';
import * as angular from 'angular';
import * as moment from 'moment';
import { ngStorage } from 'ngstorage';
import * as _ from 'underscore';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { SortOrderEnum } from '../../../model/IActiveStaffsFilter';
import { IShopperStaffDiscountTransactionFilter } from '../../../model/IShopperStaffDiscountTransactionFilter';
import {
    IShopperStaffDiscountTransactionListItem,
    IShopperStaffDiscountTransactionStatus
} from '../../../model/IShopperStaffDiscountTransactionListItem';
import { IShopperStaffDiscountTransactionsSummary } from '../../../model/IShopperStaffDiscountTransactionsSummary';
import { DiscountForStaffService } from '../../discount-for-staff.service';

class TransactionWithDiscountTab {
    public static $inject = ['$scope', '$translate', 'discountForStaffService', 'notificationService', '$state', '$localStorage'];

    public waiting: boolean;
    public total: number;
    public items: IShopperStaffDiscountTransactionListItem[] = [];
    public enumStatus = IShopperStaffDiscountTransactionStatus;
    public transactionsSummary: IShopperStaffDiscountTransactionsSummary;

    public forSearch: boolean;
    public search = {
        placeholder: '' as string,
        text: '' as string
    };

    public messages = {
        searchMessageTitle: '' as string,
        searchMessageContent: '' as string,
        emptyListMessageTitle: '' as string,
        emptyListMessageContent: '' as string,
    };

    public filter= {
        isActive: false as boolean,
        isApplied: false as boolean,
        data: {
            selectedLocations: [] as any[],
            dateFrom: moment(new Date()).add(-30, 'days').toDate() as Date,
            dateTo: new Date()
        },
        clear: () => {
            this.filter.isApplied = false;
            this.filter.data = {
                selectedLocations: [],
                dateFrom: moment(new Date()).add(-30, 'days').toDate() as Date,
                dateTo: new Date()
            };
        },
        toggle: () => {
            this.filter.isActive = !this.filter.isActive;
            if (!this.filter.isActive) {
                this.clearFilter();
            }
        },
        set: (newFilterSettings: any) => {
            this.filter.isApplied = true;
            this.filter.data = {
                selectedLocations: newFilterSettings.selectedLocations,
                dateFrom: newFilterSettings.dateFrom,
                dateTo: newFilterSettings.dateTo
            };
        }
    };

    public itemsLimit: number = 20;
    public canLoadMore: boolean = true;

    public countryID: number;

    public viewport = {
        width: $(window).width(),
        height: $(window).height(),
        scrollTop: 0
    };

    constructor(
        public $scope: ng.IScope,
        protected $translate: angular.translate.ITranslateService,
        public discountForStaffService: DiscountForStaffService,
        public notificationService: NotificationService,
        public $state: StateService,
        private $localStorage: ngStorage.StorageService
    ) {
    }

    public $onInit() {
        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
        this.loadData(false);
        $(window).resize(() => {
            this.viewport.width = $(window).width();
            this.viewport.height = $(window).height();
            this.$scope.$apply();
        });

        $(window).scroll(() => {
            this.viewport.scrollTop = $(document).scrollTop();
            this.$scope.$apply();
        });
    }

    public applySearch(searchText: string) {
        if (!this.validateFilter()) {
            return;
        }
        this.search.text = searchText;
        this.resetHistoryItemsList();
        this.loadData(searchText.length > 0);
    }

    public async resetSearch() {
        this.search.text = '';
        this.applySearch('');
    }

    public toggleFilter() {
        this.filter.toggle();
    }

    public applyFilter(newFilterSetting: any) {
        this.filter.set(newFilterSetting);
        this.applySearch(this.search.text);
    }

    public clearFilter() {
        if (this.filter.isApplied) {
            this.filter.clear();
            this.applySearch('');
        } else {
            this.filter.clear();
        }
    }

    public openTransactionDetails(id: number) {
        this.$state.go('app.discountForStaffs.transaction.singleTransaction', { id });
    }

    public loadData(forSearch: boolean) {
        if (this.waiting || !this.canLoadMore) {
            return;
        }
        this.forSearch = forSearch;
        this.waiting = true;

        const filter = {
            From: this.filter.isApplied ?
                    (this.filter.data.dateFrom ?
                        moment(this.filter.data.dateFrom).utc(true).startOf('day').toDate() :
                        null) :
                    moment(new Date()).add(-30, 'days').utc(true).startOf('day').toDate(),
            To: this.filter.isApplied ?
                    (this.filter.data.dateTo ?
                        moment(this.filter.data.dateTo).utc(true).startOf('day').toDate() :
                        null) :
                    moment(new Date()).utc(true).startOf('day').toDate(),
            Limit: 20,
            Offset: this.items.length,
            SortColumn: 'DateTime',
            SortOrder: SortOrderEnum.Descending,
            Keyword: this.search.text,
            PlacesID: this.filter.isApplied ? this.filter.data.selectedLocations.map((x) => x.ID) : null
        };

        this.notificationService.showWaitingMessage();

        this.discountForStaffService.getTransactionsSummary(filter)
            .then((response) => {
                this.transactionsSummary = response;
            })
            .catch((error) => {
                this.notificationService.showErrorMessage(error);
            });

        return this.discountForStaffService.getTransactionsWithDiscount(filter)
            .then((response) => {
                this.total = response.Total;
                Array.prototype.push.apply(this.items, response.Items);
                if (this.items && this.items.length === 0) {
                    if (this.forSearch) {
                        this.messages.searchMessageContent = this.$translate.instant('transaction_history_search_empty_content', {search: this.search.text});
                    }
                }
                this.canLoadMore = response.Items.length === this.itemsLimit;
            })
            .catch((error) => {
                this.notificationService.showErrorMessage(error);
            })
            .finally(() => {
                this.waiting = false;
                this.notificationService.clearAll();
            });
    }

    public getFilterPeriod(): string {
        return moment(this.filter.data.dateTo).utc(true).diff(moment(this.filter.data.dateFrom).utc(true), 'days').toString();
    }

    private validateFilter(): boolean {
        const dateFrom = this.filter.data.dateFrom;
        const dateTo = this.filter.data.dateTo;

        if (!dateFrom && !dateTo) {
            return true;
        }

        if (!dateFrom) {
            this.notificationService.showErrorMessage(this.$translate.instant('date_from_is_requierd_error'));
            return false;
        }

        if (!dateTo) {
            this.notificationService.showErrorMessage(this.$translate.instant('date_to_is_required_error'));
            return false;
        }

        const datesDiff = moment(dateTo).diff(dateFrom, 'seconds');
        if (datesDiff < 0) {
            this.notificationService.showErrorMessage(this.$translate.instant('invalid_date_range_error'));
            return false;
        }

        return true;
    }

    private resetHistoryItemsList() {
        this.waiting = false;
        this.canLoadMore = true;
        this.items = [];
        this.total = 0;
    }
}

angular.module('naut').component('transactionWithDiscountTab', {
    template: require('./transaction-with-discount-tab.component.html'),
    controller: TransactionWithDiscountTab,
    controllerAs: 'ctrl'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/discountForStaff/transaction-tab/transaction-with-discount-tab/transaction-with-discount-tab.component.ts